import $ from "jquery"
import Vue from "vue"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import * as ses from "../../../configurations/session/sessioncomplete"
import baseurl from "../../../configurations/baseurl/baseurl"
import router from "../../../router/index"


export const actions = {

    newUser() {
        let userDetails = {
            fullnames: $('.fullnames').val(),
            profilename: $('.profilename').val(),
            gender: $('.gender').val(),
            email: $('.email').val(),
            password: $('.password').val(),
        }
        $('.creatingUser').hide()
        $('.creatingUserLoader').show()
        baseurl
            .post(rt.newUsers, userDetails)
            .then(res => {

                $('.creatingUser').show()
                $('.creatingUserLoader').hide()
                $('.form-control').val("")
                if (res.data.code === 200) {
                    suc.userCreateSuccess()
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 403) {
                    ers.userExists()
                } else if (res.data.code === 404) {
                    ers.errorCreatingUser()
                } else if (res.data.code === 405) {
                    ers.noPermissionToCreate()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    checkPasswordStrength() {

        var number = /([0-9])/;
        var alphabets = /([a-zA-Z])/;
        var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
        if ($('#password').val().length < 6) {
            $('#password-strength-status').removeClass();
            $('#password-strength-status').addClass('weak-password');
            $('#password-strength-status').html("Weak (should be atleast 6 characters.)");
            $('#password-strength-status').css("color", "red");
        } else {
            if ($('#password').val().match(number) && $('#password').val().match(alphabets) && $('#password').val().match(special_characters)) {
                $('#password-strength-status').removeClass();
                $('#password-strength-status').addClass('strong-password');
                $('#password-strength-status').html("Strong password");
                $('#password-strength-status').css("color", "green");
                $('.creatingUser').attr('disabled', false)
            } else {
                $('#password-strength-status').removeClass();
                $('#password-strength-status').addClass('medium-password');
                $('#password-strength-status').html("Medium (should include alphabets, numbers and special characters.)");
                $('#password-strength-status').css("color", "blue");
            }
        }
    },

    loadUsers({ commit }) {
        baseurl
            .get(rt.loadUsers)
            .then(res => {

                $('.usersLoader').hide()
                if (res.data.code === 200) {
                    commit('STORE_USERS', res.data.users)
                } else if (res.data.code === 404) {
                    ers.errorLoadingUsers()
                } else if (res.data.code === 405) {
                    commit('STORE_USERS', [])
                    ers.noPermissionToRead()
                    setTimeout(() => {
                        router.push('/dashboard')
                    }, 2000);
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },

    viewUser({ commit }, userId) {
        commit('STORE_USER_UPDATE', userId)
        router.push('/updateuser')
    },

    userUpdate({ commit }) {
        let userDetails = {
            id: $('.id').val(),
            fullnames: $('.fullnames').val(),
            profilename: $('.profilename').val(),
            gender: $('.gender').val(),
            email: $('.email').val(),
            accountstatus: $('.accontstatus').val(),
        }
        $('.updatingUser').hide()
        $('.updatingUserLoader').show()
        baseurl
            .post(rt.updateUsers, userDetails)
            .then(res => {

                $('.updatingUserLoader').hide()
                $('.updatingUser').show()
                if (res.data.code === 200) {
                    suc.userUpdateSuccess()
                    commit('STORE_USERS', res.data.users)
                    setTimeout(() => {
                        router.push('/manageusers')
                    }, 3000);
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 404) {
                    ers.errorUpdatingUser()
                } else if (res.data.code === 405) {
                    ers.noPermissionToUpdate()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    deleteUser({ commit }, userId) {
        Vue.swal.fire({ title: 'Are you sure?', text: 'You want to delete this user..?!', type: "warning", showCancelButton: true }).then(result => {
            if (result.value) {
                window.$("#usersLoaderModal").modal("show");
                baseurl
                    .get(rt.deleteUser + userId)
                    .then(res => {

                        window.$("#usersLoaderModal").modal("hide");
                        if (res.data.code === 200) {
                            suc.userDeleteSuccess()
                            setTimeout(() => {
                                $('.usersLoader').show()
                                setTimeout(() => {
                                    commit('STORE_USERS', res.data.users)
                                    $('.usersLoader').hide()
                                }, 200);

                            }, 3000);

                        } else if (res.data.code === 404) {
                            ers.errorDeletingUser()
                        } else if (res.data.code === 405) {
                            ers.noPermissionToDelete()
                        } else if (res.data.code === 506) {
                            ses.sessionComplete()
                        }

                    })
            }
        })
    },

    userRoles({ commit }, userId) {
        commit('STORE_USER_UPDATE', userId)
        baseurl
            .get(rt.userRoles + userId)
            .then(res => {

                if (res.data.code === 200) {
                    commit('STORE_USER_ROLE', res.data.userRoles)
                    commit('STORE_USER_ROLE_MODULES', res.data.roleModules)
                    router.push('/userroles')
                } else if (res.data.code === 404) {
                    ers.errorLoadinguserRoles()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    
}

export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/users/actions.js